import axios, { AxiosError } from 'axios';
import { jwtService } from './jwt.service';
import WebApp from '@twa-dev/sdk';
import { authApi } from '@/api';

const TOKENS_REFRESH_ENDPOINT = '/tokens/refresh'

jwtService.initToken();

const ApiClient = axios.create({
    baseURL: process.env.REACT_APP_API_ENDPOINT,
    withCredentials: true,
    headers: {
        Authorization: jwtService.getAuthHeader(),
    },
})

const UnAuthApiClient = axios.create({
    baseURL: process.env.REACT_APP_API_ENDPOINT,
    withCredentials: true
})

ApiClient.interceptors.request.use(
    req => {
        req.headers.Authorization = jwtService.getAuthHeader()
        return req
    }
)
ApiClient.interceptors.response.use(
    res => {
        const status = res.status
        // reset isRefreshTokenWasUsed state for prevent immediate redirect to sign in form after success response
        if (
            jwtService.getRefreshTokenWasUsedState() &&
            status >= 200 &&
            status < 300
        ) jwtService.setRefreshTokenWasUsedState(false)
        return res
    },
    async err => {
        if (!(err instanceof AxiosError)) return Promise.reject(err);
        if (err.response?.status !== 401) return Promise.reject(err);
        if (err.response?.config.url === TOKENS_REFRESH_ENDPOINT) return Promise.reject(err);
        const refreshToken = jwtService.getRefreshToken()
        if (refreshToken) {
            let refreshTokenReq = jwtService.getRefreshTokenRequest()
            const hasNotRefreshTokenReq = !refreshTokenReq
            if (!refreshTokenReq) {
                refreshTokenReq = authApi.invalidateTokens(refreshToken)
                jwtService.setRefreshTokenRequest(refreshTokenReq)
            }
            try {
                jwtService.setRefreshTokenWasUsedState(true)
                let res = await refreshTokenReq
                const resData = res.data
                if (hasNotRefreshTokenReq) {
                    jwtService.setAccessToken(resData.access_token)
                    jwtService.setRefreshToken(resData.refresh_token)
                }
                const config = err.response.config
                config.headers.Authorization = jwtService.getAuthHeader()
                return ApiClient(config)
            } catch (e) {
                if (hasNotRefreshTokenReq) {
                    if (e instanceof AxiosError) {
                        if (
                            e.response?.config.url === TOKENS_REFRESH_ENDPOINT &&
                            e.response?.status === 401
                        ) {
                            console.log('refresh token is expired')
                            // prevent duplicated refresh token requests when tokens pair already invalid
                            jwtService.destroyTokenPair()
                        }
                    }
                }
            } finally {
                if (hasNotRefreshTokenReq)
                    jwtService.setRefreshTokenRequest(null)
            }
        }
        return Promise.reject(err)
    }
);

export {
    ApiClient,
    UnAuthApiClient,
    TOKENS_REFRESH_ENDPOINT,
};
